import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import { ReduxStateType } from "redux-store/types";

import { LaborContract } from "core/http/service/operationProcess/resTypes";

interface InitialState {
  status: ReduxStateType;
  data: LaborContract[];
}

const initialState: InitialState = {
  status: ReduxStateType.ERROR,
  data: [],
};

const getLaborContractSlice = createSlice({
  name: "getLaborContract",
  initialState,
  reducers: {
    getLaborContractStart: (state) => {
      state.status = ReduxStateType.LOADING;
    },
    getLaborContractSuccess: (
      state,
      action: PayloadAction<LaborContract[]>
    ) => {
      state.status = ReduxStateType.SUCCESS;
      state.data = action.payload;
    },
    getLaborContractFailed: (state) => {
      state.status = ReduxStateType.ERROR;
    },
    resetLaborContract: () => {
      return { ...initialState };
    },
  },
});

export const {
  getLaborContractStart,
  getLaborContractSuccess,
  getLaborContractFailed,
  resetLaborContract,
} = getLaborContractSlice.actions;

export default getLaborContractSlice.reducer;
